var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.868 23.868",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m0 5.0503v17.18l0.4683-0.60928 0.69949-0.88876 0.72757-0.88865 0.743-0.85616 0.74809-0.79256 0.74775-0.70006 0.75383-0.58123 0.79577-0.43291 0.84413-0.18409 0.76805 0.10257 0.63384 0.25032 0.53241 0.3337 0.45146 0.36449 0.39239 0.35926 0.34666 0.32394 0.30319 0.26005 0.24936 0.17217 0.17822 0.07997 0.02441 0.0037 0.05859-0.02105 0.35253-0.29563 0.54152-0.59744 0.63833-0.78572 0.70386-0.88628 0.75543-0.91139 0.80357-0.8681 0.86426-0.76106 0.96916-0.58194 1.0411-0.235 0.90878 0.06918 0.74517 0.18048 0.02798 0.01184v-7.8144z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.1346 10.023a2.162 2.162 0 0 0-4.324 0 2.162 2.162 0 0 0 4.324 0z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.2506 23.868h17.568v-8.7848l-0.29697-0.18448-0.35759-0.15164-0.43022-0.1042-0.45042-0.03431-0.43797 0.09889-0.54014 0.32434-0.65243 0.57452-0.69763 0.75364-0.70742 0.85347-0.69777 0.8786-0.6792 0.83605-0.66905 0.73811-0.72821 0.61068-0.86945 0.31281-0.79034-0.12294-0.5884-0.26403-0.4849-0.33478-0.41447-0.35552-0.37015-0.34591-0.33933-0.31063-0.31094-0.25106-0.27642-0.17325-0.23718-0.09368-0.18092-0.02421-0.22572 0.04921-0.40757 0.22172-0.55327 0.42662-0.6334 0.593-0.67737 0.71764-0.69705 0.80319-0.69735 0.85176-0.68058 0.86471-0.64808 0.84318z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.0503 3.0612v-1.0722h16.829v16.829h-1.0722v1.989h3.0612v-20.807h-20.807v3.0612z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalery);
export default __webpack_public_path__ + "static/media/galery.3234d14b887449cb2e50b9fc658f9f50.svg";
export { ForwardRef as ReactComponent };